import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { googleLogin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split('session_id=')[1];
    if (!sessionId) {
      navigate('/auth');
      return;
    }

    googleLogin(sessionId)
      .then(() => navigate('/'))
      .catch(() => navigate('/auth'));
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F7]">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#002FA7] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-sm text-zinc-500">Signing you in...</p>
      </div>
    </div>
  );
}
